import React from 'react';
import { StepIndicatorItem } from './components/StepIndicatorItem';
import { StepTail } from './components/StepTail';

type Props = {
  testID?: string;
  totalSteps: number;
  active: number;
};

export const StepsIndicator: React.FC<Props> = ({ totalSteps, active, testID = 'StepsIndicator' }) => {
  return (
    <div data-testid={testID} className="flex flex-row justify-center items-center">
      {Array.from(Array(totalSteps).keys()).map((item, index) => {
        const afterTail = index > 0 ? <StepTail active={index <= active} /> : null;
        return (
          <>
            {afterTail}
            <StepIndicatorItem label={(item + 1).toString()} key={index} active={index <= active} />
          </>
        );
      })}
    </div>
  );
};
